export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dopo aver completato lo scambio, verrà chiuso. I fondi interni verranno trasferiti all'utente."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sei sicuro di voler completare lo scambio?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sì, completa"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, mantieni attivo"])}
}